export enum C3Actions {
  ACTION_ACTION_LIST = 'ACTION_ACTION_LIST',
  ACTION_SYSTEM_INFO = 'ACTION_SYSTEM_INFO',
  ACTION_SYSTEM_INFO_DYNAMIC = 'ACTION_SYSTEM_INFO_DYNAMIC',
  ACTION_SYNCTHING_POST_SYSTEM_RESTART = 'ACTION_SYNCTHING_POST_SYSTEM_RESTART',
  ACTION_SYNCTHING_RESTART_SERVICE = 'ACTION_SYNCTHING_RESTART_SERVICE',
  ACTION_SYNCTHING_SUMMARIES = 'ACTION_SYNCTHING_SUMMARIES',
  ACTION_SYNCTHING_CLOUD_CONTENT_SUMMARIES = 'ACTION_SYNCTHING_CLOUD_CONTENT_SUMMARIES',
  ACTION_SHELL_SERVICE_STATUS_TUNNEL_AUTOSSH = 'ACTION_SHELL_SERVICE_STATUS_TUNNEL_AUTOSSH',
  ACTION_SHELL_SERVICE_ENABLE_TUNNEL_AUTOSSH = 'ACTION_SHELL_SERVICE_ENABLE_TUNNEL_AUTOSSH',
  ACTION_SHELL_SERVICE_DISABLE_TUNNEL_AUTOSSH = 'ACTION_SHELL_SERVICE_DISABLE_TUNNEL_AUTOSSH',
  ACTION_SYSTEM_SERVICE_LOGS_ALL = 'ACTION_SYSTEM_SERVICE_LOGS_ALL',
}

export class ConnectedSockets {
  public connectedDevices: number;
  public numOfDisconnectedConnections: number;
  public elapsedTime: { hours: number, minutes: number, seconds: number, ms: number };
  public clients: SocketClient[];
}

export class SocketClient {
  public connected: boolean;
  public id: string;
  public numOfSessions: number;
  public props: Props;
  public rooms: any;
  public sessions: SocketSession[];
}
export interface SocketSession {
  connectionNo: number;
  startDate: Date;
  endDate?: Date;
  elapsedTime: ElapsedTime;
  disconnectReason: string;
}

export class CloudAction {
  public action: string;
  public description?: string;
  public link?: string;
  public parameters?: [{
    required?: boolean;
    type?: string;
    description?: string;
    name?: string
  }];
  public sendPayload?: {
    query?: any;
    body?: any;
  };
  public body?: any;
}

export interface FolderSummariesData {
  _id: string;
  syncStatus: string;
  summaries: FolderSummary[];
}
export interface FolderSummary {
  folder: string;
  stat: FolderStat;
}
export interface FolderStat {
  doneBytes: number;
  globalBytes: number;
  needBytes: number;
  completion: number;
  state: string,
  folderErrors: string[]
};

interface Syncthing {
  connected: boolean;
  deviceId: string;
  name: string;
  startTime: Date;
  version: string;
  os: string;
}

interface Props {
  clientId: string;
  clientType: string;
  cloudAddress: string;
  syncthing: Syncthing;
  clientConnectionMid: string;
}

interface ElapsedTime {
  days: number;
  hours: number;
  minutes: number;
  ms: number;
  seconds: number;
}

interface Metadata {
  license: any[];
  product: any[];
}

interface LicenseState {
  key: string;
  licenseKey: string;
  licenseActivated: boolean;
  trialActivated: boolean;
  licenseType: string;
  metadata: Metadata;
}

interface C3Session {
  _id: string;
  parent: string;
  clientType: string;
  clientId: string;
  cloudAddress: string;
  createdDate: Date;
  licenseState: LicenseState;
  syncthing: Syncthing;
  sumSessionsMs: number;
  avgSessionsMs: number;
  minSessionsMs: number;
  maxSessionsMs: number;
  totalSessions: number;
  serverSumUpTimeSessionMs: number;
  upTimePercentage: number;
}

export interface C3Sessions {
  page: number;
  perPage: number;
  prePage?: any;
  nextPage?: any;
  totalRecords: number;
  totalPages: number;
  data: C3Session[];
}
